import $ from 'jquery';

export default function () {
  $('.offcanvas__toggler').on('click', (e) => {
    e.preventDefault();
    $('html').toggleClass('offcanvas--open');
  });
}



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/offcanvas.js